import { inject, Injectable, Signal } from '@angular/core';
import { FormResult } from '@ebeihilfe/einreichung-shared/model';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { applicationsDetailsActions } from '../actions';
import { Application } from '../models';
import { ApplicationsDetailsState } from '../reducers/applications-details.reducer';
import {
  selectApplicationsDetailsData,
  selectApplicationsDetailsError,
  selectApplicationsDetailsLoading,
  selectDocumentById,
} from '../selectors';

@Injectable()
export class ApplicationsDetailsFacade {
  private readonly store: Store<ApplicationsDetailsState> = inject(Store);

  public clearStore(): void {
    this.store.dispatch(applicationsDetailsActions.clearStore());
  }

  public deleteDocumentById(id: string): void {
    this.store.dispatch(applicationsDetailsActions.deleteDocumentById({ id }));
  }

  public loadData(applicationId: string): void {
    this.store.dispatch(applicationsDetailsActions.load({ applicationId }));
  }

  public selectData(): Signal<Application> {
    return this.store.selectSignal(selectApplicationsDetailsData);
  }

  public selectData$(): Observable<Application> {
    return this.store.select(selectApplicationsDetailsData);
  }

  public selectDocumentById(): Signal<FormResult[] | null> {
    return this.store.selectSignal(selectDocumentById);
  }

  public selectDocumentById$(): Observable<FormResult[] | null> {
    return this.store.select(selectDocumentById);
  }

  public selectError$(): Observable<{
    message: string;
    type: ReturnType<typeof applicationsDetailsActions.loadFailed>;
  }> {
    return this.store.select(selectApplicationsDetailsError);
  }

  public selectLoading(): Signal<boolean> {
    return this.store.selectSignal(selectApplicationsDetailsLoading);
  }
}
